import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Header from "../Header/Header";
import { Button, Form, FormGroup, Label, Input } from "reactstrap";
import { AuthContext } from "../../contexts/AuthContext";
import Footer from "../Footer/Footer";
import "./Login.css";
// import logo from "./Logo.png";
import Swal from "sweetalert2";
import { jwtDecode as decode } from 'jwt-decode'

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [tiendas, setTiendas] = useState([]);
  const [selectedArea, setSelectedArea] = useState("");
  const [cajas, setCajas] = useState([]);
  const [selectedCaja, setSelectedCaja] = useState("");
  const { loginUser, user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [text, setText] = useState(false);

  useEffect(() => {
    axios
      .get(`${import.meta.env.VITE_URL_AREAS}/tiendas`)
      .then((res) => {
        setTiendas(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function handleAreaChange(areaId) {
    setSelectedArea(areaId);
    setSelectedCaja("");
    setCajas([]);
    if (areaId) {
      axios
        .get(`${import.meta.env.VITE_URL_CAJAS}Login/${areaId}`)
        .then((res) => {
          setCajas(res.data.filter((c) => c.is_active === "Si"));
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  function handleClick() {
    navigate("/Inicio");
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    const jsonSend = {
      email,
      password,
    };

    if (selectedArea) {
      jsonSend.selectedArea = selectedArea;
    }
    if (selectedCaja) {
      jsonSend.selectedCaja = selectedCaja;
    }

    const LOGIN_URL = import.meta.env.VITE_URL_LOGIN;
    try {
      const res = await axios.post(LOGIN_URL, jsonSend);
      loginUser(res.data.token);
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Bienvenido",
        showConfirmButton: false,
        timer: 2000,
      });
      handleClick();
    } catch (error) {
      const msg =
        error.response?.data?.message ||
        error.response?.data?.error ||
        (typeof error.response?.data === "string" ? error.response.data : null) ||
        error.message ||
        "Error desconocido";
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: msg,
      });
      console.log(error);
    }
  };

  document.body.classList.add("white-content")

  return (
    <>
      {/* <Header /> */}
      <div className="container col-sm-5">
        <div className="card login">
          <img
            src={"/Logo-Sistemify-Login.png"}
            height="10%"
            width="100%"
            alt="auto"
          />
          <div className="body">
            <Form className="container" onSubmit={handleSubmit}>
              <div className="row">
                <FormGroup className="col-sm-6">
                  <Label>Email</Label>
                  <Input
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    type="email"
                    placeholder="type your email"
                  />
                </FormGroup>
                <FormGroup className="col-sm-6">
                  <Label>Password</Label>
                  <Input
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    type="password"
                    placeholder="type your password here"
                  />
                </FormGroup>
              </div>
              <div className="row">
                <FormGroup className="col-sm-12">
                  <Label>Almacen / Tienda (opcional)</Label>
                  <Input
                    type="select"
                    value={selectedArea}
                    onChange={(e) => handleAreaChange(e.target.value)}
                  >
                    <option value="">-- Mi almacen registrado --</option>
                    {tiendas.map((tienda) => (
                      <option key={tienda._id} value={tienda._id}>
                        {tienda.name}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              </div>
              {selectedArea && cajas.length > 0 && (
                <div className="row">
                  <FormGroup className="col-sm-12">
                    <Label>Punto de Venta / Caja</Label>
                    <Input
                      type="select"
                      value={selectedCaja}
                      onChange={(e) => setSelectedCaja(e.target.value)}
                    >
                      <option value="">-- Selecciona tu caja --</option>
                      {cajas.map((caja) => (
                        <option key={caja._id} value={caja._id}>
                          {caja.nombre}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </div>
              )}
              <Button id="botonlogin" color="success">
                Login
              </Button>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
